import DefaultProps from '../../commonTypes/defaultprops.types';
import Handler from '../../commonTypes/handler.types';

export interface NavProps extends DefaultProps {
    type?: NavTypes;
    active?: number;
    data: NavData;
    handlers?: Handler;
}
  
export type NavData = {
    label: string;
    url?: string;
}[];
  
export enum NavTypes {
    MEDIUM = 'medium',
    LARGE = 'large'
}